<template>
  <div class="page">
    <i v-if="!isDmm" class="bg" :style="bg"></i>
    <i v-if="isDmm" class="bg" :style="dmmbg"></i>
    <H5Header></H5Header>
    <router-view></router-view>
    <div class="j-game-page" id="j-game-page">
      <GameIframe
        :isFbCanvas="false"
        :class="{ fullscreen: fullScreenState }"
      ></GameIframe>
      <a
        href="javascript:;"
        class="full-screen"
        v-if="isOpenFull"
        v-show="!fullScreenState"
        @click="fullscreen"
      >
        <img :src="fullScreenIcon" />
      </a>
      <a
        href="javascript:;"
        class="full-screen-close"
        v-if="isOpenFull"
        v-show="fullScreenState"
        @click="exitfullscreen"
      >
        <img :src="fullScreenCloseIcon" />
      </a>
      <!-- 左侧跳转按钮 -->
      <a
        v-if="!isSpecial && !isDmm && isOpenLeftJumpLink"
        class="left-jump-link"
        target="_blank"
        :href="getCurJumpLink(leftLink)"
      >
        <img :src="leftLinkBg" />
      </a>
    </div>
    <div
      v-if="isOpenGiftFloat"
      class="gift-float-popup"
      v-show="giftFloatState"
    >
      <img class="gift-float-bg" :src="giftFloatBody" />
      <img
        class="gift-close"
        :src="giftFloatClose"
        v-if="giftFloatClose"
        @click="giftFloatState = false"
      />
      <div class="gift-btn-group">
        <p>
          <a class="gift-favour-btn" v-if="giftFloatFavour" @click="favourFn">
            <img :src="giftFloatFavour" />
          </a>
          <a
            class="gift-download-btn"
            v-if="giftFloatDownload"
            @click="downloadFn"
          >
            <img :src="giftFloatDownload" />
          </a>
        </p>
        <a class="gift-list-btn" v-if="giftFloatListBtn">
          <img :src="giftFloatListBtn" />
        </a>
      </div>
    </div>
    <Qrcode v-if="!isSpecial && !isDmm"></Qrcode>
    <!-- <iframe
      src="//jpabres.37games.com/html/passport.html?apps=&country=JP&devicePlate=pc&gameId=2&hideSDKLogo=1&gpid=&if_back=1&portrait=1&roleId=&roleName=&serverId=&userName=&zone=&h5=1&web=1#/"
      width="300"
      height="600"
    ></iframe> -->
    <H5Footer v-if="!isDmm"></H5Footer>
    <div
      class="dmm-music-tips"
      v-if="isDmm && showMusicTipsDmm"
      @click="controlMusicTipsDmm"
    >
      <div class="music-tips-content"></div>
    </div>
    <div class="dmm-faq-tips" v-if="isDmm && showFaqTipsDmm">
      <div class="faq-tips-content">
        <div class="head">利用規約への同意</div>
        <p class="tips">*以下の規約への同意が必要です</p>
        <a
          class="read-service"
          href="http://gpassport.37games.com/center/JpServicePrivicy/service"
          target="_blank"
          >利用規約</a
        >
        <a
          class="read-privicy"
          href="http://gpassport.37games.com/center/JpServicePrivicy/privicy"
          target="_blank"
          >プライバシーポリシー</a
        >
        <div class="agree" @click="controlFaqTipsDmm">同意する</div>
      </div>
    </div>
    <div class="beauty-faq-tips" v-if="!isDmm && showFaqTipsBeauty">
      <div class="faq-tips-content">
        <div class="head">利用規約への同意</div>
        <p class="tips">*以下の規約への同意が必要です</p>
        <a
          class="read-service"
          href="http://gpassport.37games.com/center/JpServicePrivicy/service"
          target="_blank"
          >利用規約</a
        >
        <a
          class="read-privicy"
          href="http://gpassport.37games.com/center/JpServicePrivicy/privicy"
          target="_blank"
          >プライバシーポリシー</a
        >
        <div class="agree" @click="controlFaqTipsBeauty">同意する</div>
      </div>
    </div>

    <CommonTips v-show="commonTips"></CommonTips>
    <NoticePopup></NoticePopup>
  </div>
</template>

<script>
import GameIframe from '../components/GameIframe';
import H5Header from '../components/H5Header';
import H5Footer from '../components/H5Footer';
import Qrcode from '../components/Qrcode';
import CommonTips from '../components/CommonTips';
import NoticePopup from '../components/NoticePopup';
import globalConfig from '../utiles/globalConfig';
import { HREF_IS_DMM } from '../store/web/h5';
import { mapGetters } from 'vuex';
import favour from '../mixins/favour';
import download from '../mixins/download';
import noticePopup from '../mixins/NoticePopup';

export default {
  name: 'h5pc',
  data() {
    return {
      gameId: +window.gameId,
      bg: `background-image:url(${window.pageInfo.bg})`,
      dmmbg: `background-image:url(${window.pageInfo.dmmbg})`,
      isDmm: HREF_IS_DMM,
      showMusicTipsDmm: !sessionStorage.getItem('hasShowMusicTipsDmm'),
      showFaqTipsDmm: false,
      // showFaqTipsBeauty: !localStorage.getItem('hasShowFaqTipsBeauty')
      showFaqTipsBeauty: false,

      isOpenFull:
        window.pageInfo.full_screen && window.pageInfo.full_screen_close, //是否开启全屏功能
      fullScreenState: false, //是否处于全屏状态
      fullScreenIcon: window.pageInfo.full_screen,
      fullScreenCloseIcon: window.pageInfo.full_screen_close,

      isOpenGiftFloat:
        window.pageInfo.gift_popup.body &&
        (window.pageInfo.gift_popup.favour ||
          window.pageInfo.gift_popup.download), // 是否开启礼包浮窗
      giftFloatState: true,
      giftFloatBody: window.pageInfo.gift_popup.body,
      giftFloatClose: window.pageInfo.gift_popup.close,
      giftFloatFavour: window.pageInfo.gift_popup.favour,
      giftFloatDownload: window.pageInfo.gift_popup.download,
      giftFloatListBtn: window.pageInfo.gift_popup.list,
      isOpenLeftJumpLink:
        window.pageInfo.left_jump_link &&
        window.pageInfo.left_jump_link.bg &&
        window.pageInfo.left_jump_link.link, // 是否开启左边跳转入口
      leftLink: window.pageInfo.left_jump_link.link,
      leftLinkBg: window.pageInfo.left_jump_link.bg
    };
  },
  computed: {
    ...mapGetters(['commonTips']),
    isSpecial() {
      return (
        this.gameId === 2 && window.location.host.split('.')[0] === 'naisitsu'
      ); // 针对江美naisitsu.37games.com域名页面特殊处理
    }
  },
  mixins: [favour, download, noticePopup],
  methods: {
    getCurJumpLink(link) {
      return window.globalGetGotoLink({ link });
    },
    controlMusicTipsDmm() {
      this.showMusicTipsDmm = false;
      sessionStorage.setItem('hasShowMusicTipsDmm', 1);
      this.showFaqTipsDmm = !localStorage.getItem('hasShowFaqTipsDmm');
    },
    controlFaqTipsDmm() {
      this.showFaqTipsDmm = false;
      localStorage.setItem('hasShowFaqTipsDmm', 1);
    },
    controlFaqTipsBeauty() {
      this.showFaqTipsBeauty = false;
      localStorage.setItem('hasShowFaqTipsBeauty', 1);
    },
    updateFullScreenState() {
      if (this.fullScreenState) {
        window.removeEventListener('resize', this.updateFullScreenState);
      }
      this.fullScreenState = !this.fullScreenState;
    },
    fullscreen() {
      let element = document.getElementById('j-game-page');
      this.excFullscreen(element);
      window.addEventListener('resize', this.updateFullScreenState);
    },
    exitfullscreen() {
      window.removeEventListener('resize', this.updateFullScreenState);
      this.excExitFullScreen();
      this.fullScreenState = false;
    },
    excExitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    excFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      }
    },
    setBgImage() {
      this.bg = this.isSpecial
        ? `background-image: url('https://cdnimages.awselbcombine.com/public_images/one_image/2023/05/16847208203744.jpg')`
        : `background-image:url(${window.pageInfo.bg})`;
    }
  },
  created() {
    this.setBgImage();
    this.showTipPopupEntry()
  },
  components: {
    GameIframe,
    H5Header,
    Qrcode,
    CommonTips,
    H5Footer,
    NoticePopup
  }
};
</script>

<style lang="scss">
@import '../assets/scss/h5.scss';
.page {
  background-color: black;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  position: relative;
  font-family: 'SourceHanSansCN-Light';
}
.bg {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 0;
  left: 50%;
  width: 2560vh;
  height: 1113vh;
  margin-left: -1280vh;
  z-index: 1;
}

.game-content {
  height: 960vh;
  width: 640vh;
  margin: 74vh auto 0;
  display: block;
  position: relative;
  z-index: 2;
}

.left-jump-link {
  position: absolute;
  bottom: 30vh;
  right: 50%;
  z-index: 1;
  margin-right: 450vh;
}
</style>
